import { scheduleActions, scheduleSelectors } from 'features/schedule/redux';
import { useAppDispatch } from 'shared/services/redux/hooks/use-dispatch';
import { useAppSelector } from 'shared/services/redux/hooks/use-selector';

export const useLessonDetails = () => {
  const dispatch = useAppDispatch();

  const selectedLesson = useAppSelector(scheduleSelectors.getSelectedLesson);

  const handleCloseLessonDetails = () => {
    dispatch(scheduleActions.setSelectedLesson(null));
  };

  return {
    state: {
      selectedLesson,
    },
    methods: {
      handleCloseLessonDetails,
    },
  };
};
